import type { APIComponentAttributes } from '@ardoq/api-types';
import { GraphItemModel } from './GraphItem';
import type { Node } from './types';
import type { ComponentTypeInfo } from './componentTypeInfo';
import { DefaultNode } from './DefaultNode';
import { ComponentNode } from './ComponentNode';

export type GetComponentTypeInfo = (
  component: APIComponentAttributes
) => ComponentTypeInfo;

export const createComponentNode = (options: {
  dataModel: APIComponentAttributes;
  parent?: Node<GraphItemModel>;
  getComponentTypeInfo: GetComponentTypeInfo;
}): Node<APIComponentAttributes> => {
  const { dataModel, parent, getComponentTypeInfo } = options;
  return new ComponentNode({
    dataModel,
    parent,
    typeInfo: getComponentTypeInfo(dataModel),
  });
};

export function createNode<T extends GraphItemModel>(options: {
  dataModel: T;
  parent?: Node<GraphItemModel>;
}): Node<T> {
  return new DefaultNode(options) as unknown as Node<T>;
}
